import './category-calc.component.scss'

import customSelect from 'custom-select'
import './../../styles/modules/plugins/custom-select.scss'

import IMask from 'imask'

class ProductChanger {
  constructor(elements) {
    this.elements = elements

    this.init()
  }

  onStart() {
    this.elements.list.forEach(item => {
      if (item.checked) {
        const name = item.value

        const media = this.elements.section.querySelector(`.category-calc__col-media [data-product='${name}']`)
        const form = this.elements.section.querySelector(`.category-form[data-product='${name}']`)

        if (media) {
          media.classList.add('active')

          const mediaVideo = media.querySelector('video')
          if (mediaVideo) {
            mediaVideo.load()
            mediaVideo.play()
          }
        }
        if (form) {
          form.classList.add('active')
        }
      }
    })
  }

  onChange() {
    this.elements.list.forEach(item => {
      item.addEventListener('change', e => {
        const oldDeactive = () => {
          const oldMedia = this.elements.section.querySelector('.category-calc__col-media .active')
          const oldForm = this.elements.section.querySelector('.category-form.active')
  
          if (oldMedia) {
            oldMedia.classList.remove('active')

            const mediaVideo = oldMedia.querySelector('video')
            if (mediaVideo) {
              mediaVideo.pause()
            }
          }
          if (oldForm) {
            oldForm.classList.remove('active')
          }
        }
        const currentActive = () => {
          const name = item.value
  
          const media = this.elements.section.querySelector(`.category-calc__col-media [data-product='${name}']`)
          const form = this.elements.section.querySelector(`.category-form[data-product='${name}']`)
  
          if (media) {
            media.classList.add('active')

            const mediaVideo = media.querySelector('video')
            if (mediaVideo) {
              mediaVideo.load()
              mediaVideo.play()
            }
          }
          if (form) {
            form.classList.add('active')
          }
        }

        oldDeactive()
        currentActive()
      })
    })
  }

  init() {
    this.onStart()
    this.onChange()
  }
}

class CategoryCalcPlugins {
  constructor(elements) {
    this.elements = elements

    this.init()
  }

  selects() {
    this.elements.selects.forEach(select => {
      select.addEventListener('change', () => {
        const customContainer = select.closest('.custom-select-container')
        if (customContainer) {
          if (select.value) {
            customContainer.classList.add('filled')
          } else {
            customContainer.classList.remove('filled')
          }
        }
      })

      customSelect(select)
    })
  }

  masks() {
    this.elements.sizeInputs.forEach(input => {
      const settings = {
        mask: 'WIDTH.WIDTH_DEC x HEIGHT.HEIGHT_DEC',
        placeholderChar: '0',
        blocks: {
          WIDTH: {
            mask: IMask.MaskedRange,
            from: 10,
            to: 99,
          },
          HEIGHT: {
            mask: IMask.MaskedRange,
            from: 10,
            to: 99,
          },
          WIDTH_DEC: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 99,
          },
          HEIGHT_DEC: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 99,
          },
        }
      }
      
      IMask(input, settings)
    })
  }

  inputs() {
    this.elements.sizeInputs.forEach(input => {
      input.addEventListener('blur', () => {
        const pattern = new RegExp(input.pattern)

        if (pattern.test(input.value)) {
          input.classList.add('filled')
        } else {
          input.classList.remove('filled')
        }
      })
    })
  }

  init() {
    this.selects()
    this.masks()
    this.inputs()
  }
}

class CategoryCalcQuantity {
  constructor(elements) {
    this.elements = elements

    this.init()
  }

  setEvents() {
    this.elements.quantities.forEach(item => {
      const input = item.querySelector('input')
      const minus = item.querySelector('.category-form__quantity-minus')
      const plus = item.querySelector('.category-form__quantity-plus')

      const min = +input.min
      const max = +input.max

      minus.addEventListener('click', () => {
        if (Number(input.value) - 1 >= min) {
          input.value = Number(input.value) - 1
        }
      })

      plus.addEventListener('click', () => {
        if (Number(input.value) + 1 <= max) {
          input.value = Number(input.value) + 1
        }
      })
    })
  }

  init() {
    this.setEvents()
  }
}

class CategoryCalcSubmits {
  constructor(elements) {
    this.elements = elements
    this.data = {
      current: {},
      cart: {}
    }
    this.counter = 0
    
    this.init()
  }

  submitsOff() {
    this.elements.section.querySelectorAll('.category-form').forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault()
      })
    })
  }

  resetBtns() {
    this.elements.wraps.order.classList.add('active')
    this.elements.wraps.ending.classList.remove('active')
  }

  reset() {
    const forms = this.elements.section.querySelectorAll('.category-form')
    forms.forEach(form => {
      form.querySelector('[type="reset"]').click()
      form.querySelectorAll('select').forEach(select => {
        select.dispatchEvent(new Event('change'))
      })
      // form.querySelector('.category-form__input[name="size"]').value = '00 x 00'
    })

    this.data.current = {}
  }

  addProduct() {
    const form = this.elements.section.querySelector('.category-form.active')
    const formData = new FormData(form)
    const formDataEntries = Object.fromEntries(formData.entries())
    const product = form.dataset.product

    let isFormSubmit = true
    const notPassedCeils = []

    form.querySelectorAll('.category-form__ceil').forEach(item => {
      let passedInput = true

      const inputName = item.querySelector('[name]').name

      const isInData = inputName in formDataEntries

      if (isInData) {
        const isNotValue = !formDataEntries[inputName]

        if (isNotValue) {
          passedInput = false
          
          item.classList.add('invalid')
          form.addEventListener('mouseover', () => {
            setTimeout(() => {
              item.classList.remove('invalid')
            }, 2000)
          }, {
            once: true
          })
          form.addEventListener('touchstart', () => {
            setTimeout(() => {
              item.classList.remove('invalid')
            }, 2000)
          }, {
            once: true
          })
        } else {
          const patternInput = item.querySelector('[pattern]')
          if (patternInput) {
            const pattern = new RegExp(patternInput.pattern)

            if (!pattern.test(patternInput.value)) {
              passedInput = false
              
              item.classList.add('invalid')
              form.addEventListener('mouseover', () => {
                setTimeout(() => {
                  item.classList.remove('invalid')
                }, 2000)
              }, {
                once: true
              })
              form.addEventListener('touchstart', () => {
                setTimeout(() => {
                  item.classList.remove('invalid')
                }, 2000)
              }, {
                once: true
              })
            }
          }
        }
      } else {
        passedInput = false
        
        item.classList.add('invalid')
        form.addEventListener('mouseover', () => {
          setTimeout(() => {
            item.classList.remove('invalid')
          }, 2000)
        }, {
          once: true
        })
        form.addEventListener('touchstart', () => {
          setTimeout(() => {
            item.classList.remove('invalid')
          }, 2000)
        }, {
          once: true
        })
      }

      if (!passedInput) {
        isFormSubmit = false
      } else {
        this.elements.btns.ending.classList.remove('disabled')
      }
    })

    if (isFormSubmit) {
      this.data.current.product = product
      this.data.current.settings = Object.fromEntries(formData.entries())
  
      this.elements.btns.cart.classList.add('active')
      this.data.cart[`id_${this.counter++}`] = this.data.current
      this.elements.btns.cart.dataset.count = Object.keys(this.data.cart).length
    }
  }

  pushResults() {
    const resField = this.elements.popup.querySelector('.wpforms-field-textarea textarea') || this.elements.popup.querySelector('#categoryResults')
    const resList = this.elements.popup.querySelector('.category-popup-form__order-list')
    resList.innerHTML = ''
    let resValue = ''

    // resField.value = JSON.stringify(this.data.cart)
    for(const key in this.data.cart) {
      const cartItem = document.createElement('li')
      cartItem.dataset.productId = key

      const productCeil = document.createElement('div')
      const titleSpan = document.createElement('span')
      const sizeText = this.data.cart[key].settings.size
      const productNameText = this.data.cart[key].product
      titleSpan.innerHTML = `${sizeText} - ${(productNameText.charAt(0).toUpperCase() + productNameText.slice(1)).replace('_', ' ').replace('_', ' ')}`
      productCeil.append(titleSpan)

      resValue += `${sizeText} - ${(productNameText.charAt(0).toUpperCase() + productNameText.slice(1)).replace('_', ' ').replace('_', ' ')}:\n`
      resValue += `Quantity = ${this.data.cart[key].settings.quantity};\n`

      for(const option in this.data.cart[key].settings) {
        if (option !== 'quantity' && option !== 'size') {
          const span = document.createElement('span')
          span.innerHTML = `${(option.charAt(0).toUpperCase() + option.slice(1)).replace('_', ' ').replace('_', ' ')}: ${this.data.cart[key].settings[option].replace('_', ' ').replace('_', ' ')}`
          productCeil.append(span)

          resValue += `${(option.charAt(0).toUpperCase() + option.slice(1)).replace('_', ' ').replace('_', ' ')} = ${this.data.cart[key].settings[option].replace('_', ' ').replace('_', ' ')};\n`
        }
      }
      cartItem.append(productCeil)

      const quantityCeil = document.createElement('div')
      quantityCeil.innerHTML = this.data.cart[key].settings.quantity
      cartItem.append(quantityCeil)

      resValue += ' - \n'

      const deleteCeil = document.createElement('div')
      const deleteBtn = document.createElement('div')
      deleteBtn.classList.add('category-popup-form__delete')
      deleteBtn.addEventListener('click', e => {
        e.preventDefault()

        cartItem.remove()
        delete this.data.cart[key]
        
        resField.value = this.data.cart

        this.elements.btns.cart.dataset.count = Object.keys(this.data.cart).length
        if (!Object.keys(this.data.cart).length) {
          this.elements.popup.closest('.popup-layout').querySelector('.popup-layout__close').click()
          this.elements.btns.cart.classList.remove('active')
        }
      })
      deleteCeil.append(deleteBtn)
      cartItem.append(deleteCeil)

      resList.append(cartItem)

      resField.value = resValue
    }
  }

  setOrder() {
    this.elements.btns.order.addEventListener('click', e => {
      e.preventDefault()

      this.elements.wraps.order.classList.remove('active')
      this.elements.wraps.ending.classList.add('active')
      this.addProduct()

      if (!Object.keys(this.data.cart).length) {
        this.elements.btns.ending.classList.add('disabled')

        document.querySelector('.category-calc__forms-list').addEventListener('click', () => {
          this.resetBtns()
        }, {
          once: true
        })
      } else {
        this.reset()
      }
    })
  }

  setContinue() {
    this.elements.btns.continue.addEventListener('click', e => {
      e.preventDefault()

      // this.addProduct()
      if (Object.keys(this.data.cart).length) {
        this.resetBtns()
        this.reset()
      } else {
        this.elements.btns.ending.classList.add('disabled')
        this.elements.wraps.order.classList.add('active')
        this.elements.wraps.ending.classList.remove('active')
      }
    })
  }

  setEnding() {
    this.elements.btns.ending.addEventListener('click', e => {
      e.preventDefault()
      
      this.addProduct()
      if (Object.keys(this.data.cart).length) {
        this.pushResults()
        this.resetBtns()
        this.reset()
      } else {
        this.elements.btns.ending.classList.add('disabled')
      }
    })
    
    this.elements.btns.cart.addEventListener('click', e => {
      e.preventDefault()
      
      if (Object.keys(this.data.cart).length) {
        this.pushResults()
        this.resetBtns()
        this.reset()
      } else {
        this.elements.btns.ending.classList.add('disabled')
      }
    })
  }

  setEvents() {
    this.submitsOff()

    this.setOrder()
    this.setContinue()
    this.setEnding()
  }

  init() {
    this.setEvents()
  }
}

class CategoryCalc {
  constructor(elements) {
    this.elements = elements

    this.init()
  }

  init() {
    new ProductChanger({
      section: this.elements.section,
      list: this.elements.section.querySelectorAll('.category-calc__product-control')
    })

    new CategoryCalcPlugins({
      selects: this.elements.section.querySelectorAll('select'),
      sizeInputs: this.elements.section.querySelectorAll('.category-form__input[name="size"]'),
    })

    new CategoryCalcQuantity({
      quantities: this.elements.section.querySelectorAll('.category-form__quantity'),
    })

    new CategoryCalcSubmits({
      section: this.elements.section,
      popup: document.querySelector('.popup-category'),
      wraps: {
        order: this.elements.section.querySelector('.category-calc__wr-order'),
        ending: this.elements.section.querySelector('.category-calc__wr-ending'),
      },
      btns: {
        order: this.elements.section.querySelector('.category-calc__order-btn'),
        ending: this.elements.section.querySelector('.category-calc__ending-btn'),
        continue: this.elements.section.querySelector('.category-calc__continue-btn'),
        cart: this.elements.section.querySelector('.category-calc__cart-open')
      }
    })
  }
}

const categoryCalcEl = document.querySelector('.category-calc')
if (categoryCalcEl) {
  new CategoryCalc({
    section: categoryCalcEl
  })
}